import baseAPI from './baseAPI';
import { Holiday, HolidayCreateRequest, HolidayUpdateRequest, HolidayCheckResponse, ApiResponse } from '../types/api';

// 휴일 목록 조회 (월별)
const getHolidays = (params: { year?: number; month?: number }) => {
  return baseAPI.get<ApiResponse<Holiday[]>>('/holidays', { params });
};

// 특정 날짜가 휴일인지 확인
const checkHoliday = (date: string) => {
  return baseAPI.get<ApiResponse<HolidayCheckResponse>>('/holidays/check', { params: { date } });
};

// 휴일 생성 (선생님 전용)
const createHoliday = (data: HolidayCreateRequest) => {
  return baseAPI.post<ApiResponse<Holiday>>('/holidays', data);
};

// 휴일 수정 (선생님 전용)
const updateHoliday = (id: number, data: HolidayUpdateRequest) => {
  return baseAPI.patch<ApiResponse<Holiday>>(`/holidays/${id}`, data);
};

// 휴일 삭제 (선생님 전용)
const deleteHoliday = (id: number) => {
  return baseAPI.delete<ApiResponse<void>>(`/holidays/${id}`);
};

export const holidayAPI = {
  getHolidays,
  checkHoliday,
  createHoliday,
  updateHoliday,
  deleteHoliday
};
